var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSidebarWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 12L18.6 19L18.6 5L13 12Z",
    fill: "#FCFEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12L10.6 19L10.6 5L5 12Z",
    fill: "#FCFEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSidebarWhiteIcon);
export default __webpack_public_path__ + "static/media/close_sidebar_white_icon.fa2fdd1b264596499a3fe9f1538a3731.svg";
export { ForwardRef as ReactComponent };